//繁體 中文
module.exports = {
  // 公共語言檔
  Common: {
    quitTips1: '親愛的小朋友，妳的學習時間已經很長，<br>將會自動退出',
    quitTips2: '親愛的小朋友，妳已經學習很久了，<br>建議妳退出本應用，去休息一會兒吧',
    confirm:'確定',
    cancle:'取消',
    fininsh:'完成',
    man:'男',
    woman:'女',
    quit:'退出',
    quitEvalute:'退出挑戰',
    tips:'提示',
    confirmQuit:'確定退出',
    think:'我再想想',
    quitLogin:'退出登錄',
    quitAccount:'是否退出當前帳戶？',
    invalid:'是否退出挑戰？本次挑戰將作廢',
    timeOut:'挑戰超時，本次練習作廢',
    PleaseAnswer:'請作答',
    confirmDelete:'確定刪除',
    loadCountine:'載入更多...',
    title:'奇趣Online',
    kctvOne:'互動課堂',
    kctvTwo:'聚焦課堂',
    subject: '題'
  },
  //頭部
  Header:{
    review:'複習',
    evaluation:'測評',
    FunClass:'趣課堂',
    vedio:'影片',
    book:'圖書',
    task:'作業任務',
    myTask:'我的任務',
    studyCenter:'學習中心',
    myCenter:'個人中心',
    noData1:'暫無作業任務資料',
    noData:'暫時沒有課時任務',
    quitAccount:'是否退出當前帳戶？',
    isQuit:'是否退出練習？本次練習將作廢',
  },
  //登錄
  Login:{
    account:'帳號密碼登錄',
    phone:'手機快速登錄',
    phTips1:'帳號/手機號碼',
    phTips2:'請輸入密碼',
    rember:'記住密碼',
    forget:'忘記密碼？',
    phonePH:'請輸入手機號碼',
    verifyPH:'請輸入驗證碼',
    login:'登錄',
    getPsw:'獲取驗證碼',
    phoneNull:'手機號碼不能為空',
    phoneTips:'請輸入正確的手機號碼',
    again:'重新獲取',
    placeYourPhone:'請輸入手機號'
  },
  //忘記密碼
  Forget:{
    reset:'重置密碼',
    verifyIdentidy:'驗證身份',
    setNew:'設置新密碼',
    setSuccess:'設置成功',
    phonePH:'請輸入手機號碼',
    verifyPH:'請輸入驗證碼',
    newpswpH:'請輸入新密碼',
    againpsw:'請再次輸入新密碼',
    resetSuccess:'密碼修改成功！',
    getVerify:'獲取驗證碼',
    phoneNull:'手機號碼不能為空',
    phoneTips:'請輸入正確的手機號碼',
    againGet:'重新獲取',
    noNull:'密碼不可為空',
    changepsw:'修改密碼請輸入6位以上的字母或數字',
    changepsw1:'兩次密碼不相等'
  },
  //首頁
  Home:{
    noName:'未知名',
    noSchool:'暫時沒有學校',
    noClass:'暫時沒有班級',
    noData1:'暫時沒有作業任務資料',
    noData:'暫時沒有課時任務',
  },
  //個人中心
  MyCenter:{
    currentBaby:'當前寶寶',
    currentBabyInfo:'當前寶寶資訊',
    schoolName:"學校名稱：",
    className:'班級名稱：',
    brand:'班級編號：',
    code:'班別：',
    birthday:'出生日期：',
    pswChange:'密碼切換',
    verifty:'驗證碼切換',
    band:'您當前綁定的手機號碼',
    pswHD:'請輸入密碼',
    veriftyHD:'請輸入驗證碼',
    changeBaby:'切換寶寶',
    getCode:'獲取驗證碼',
    againget:'重新獲取',
    goldSource:'金幣來源',
    deSource:'鑽石來源',
    singe:'個',
    source:'來源',
    studyCount:'學習統計',
    studyHour:'學習課時：',
    hour:'次數',
    fininshTask:'活動記錄：',
    reviewTask:'完成活動闖關關卡：',
    myEvalute:'自我練習測評：',
    read:'閱讀書籍：',
    times:'次',
    book:'本',
    visit:'觀看動畫影片：',
    listenMp3:'聽',
    monthGet:'本月獲得',
    getWeek:'按周選擇',
    getMonth:'按月選擇',
    to:'至',
    setting:'設置',
    setMusic:'背景音樂',
    reword:'獎勵來源',
    trace:'學習軌跡',
    recordTipText1: '暫無金幣來源哦',
    recordTipText2: '暫無鑽石來源哦',
    pswTips:'密碼請填入6位以上的字母和數字'
  },
  //測評中心
  Evaluation:{
    myReport: '我的報告',
    explain: '說明',
    unit:'單元練習',
    wrong:'錯題練習',
    record:'測評記錄',
    groupUnit:'組合練習',
    itemTest:'分項測驗',
    start:'開始練習',
    dearFriend:'親愛的小朋友',
    all:'請再挑戰',
    allSchoolTip: '你目前的錯題共',
    question:'題',
    complete:'交卷',
    prev:'上一題',
    next:'下一題',
    AnsweringArea:'作答區域',
    questionArea:'題目區域',
    answerResult:'挑戰結果',
    analysis:"解析",
    good:'非常棒！',
    ComeOn:'再接再厲，繼續加油哦～',
    wrongQuestion:'再次挑戰',
    againTest:'再次挑戰',
    getMonery:'恭喜獲得獎勵',
    goBack:'返回測評首頁',
    removeQuestion:'移除錯題',
    questionTitle:'關卡分析',
    remove:'移除錯題',
    content1:'親愛的小朋友，恭喜你這道題答對了！',
    content2:'如果這道題你已經瞭解了，請點擊移除按鈕可以把這道題從錯題庫移除！',
    content3:'以後不用再練習這道題喔！',
    RemoveConfirm:'移除',
    ability:'能力指標分析',
    ablityAnaly:'能力分析',
    testAnaly:'報告',
    dearChild:'親愛的小朋友，暫時還沒有測評記錄哦',
    submitQuestion: '提交'
  },
  //任務中心
  TaskCenter:{
    historyTask:'歷史任務',
    studyTask:'學習目標',
    goback:'返回簡介',
    RecordingTask:'錄音任務',
    noFinessed:'未完成',
    Finessed:'已完成',
    goFinessed:'去完成',
    task1:'i探險',
    task2:'檢測任務',
    task3:'i互動',
    task4:'閱讀任務',
    task5:'親子任務',
    task6:'錄音任務',
    choose:'請選擇',
    load1:'請下載"奇趣Online" App 進行遊戲！',
    load2:'請到家長端完成',
    load3:'請下載"奇趣Online" App 完成錄音！',
  },
  //複習,MP3,影片,圖書
  blendType:{
    bookName:'請輸入您想看的書名',
    noBook:'親愛的小朋友，暫時還沒有的圖書哦！',
    read:'立即閱讀',
    cancleLove:'取消',
    love:'喜歡',
    suitage:'選擇適合的年齡',
    suitBook:'選擇圖書的類型',
    allBook:'全部書籍',
    noVedio:'親愛的小朋友，暫時還沒有的影片哦！',
    reword:'恭喜獲得獎勵！',
    review:'KC TV',
    book:'KC Talk',
    forword:'敬請期待！',
    noAudio:'親愛的小朋友，暫時還沒有的音訊哦！',
    isQuit:'是否退出複習？',
    load:'請下載"奇趣Online" App 進行遊戲！',
    noLove:'親愛的小朋友，你還沒有收藏喜歡的影片哦！',
    nowPlay:'立即播放',
    Replay:'重新播放',
    alread:'已讀',
    myloveBook:'我喜歡的書籍',
    zhong:'中',
    ying:'英',
    allVedio:'全部影片',
    myLoveVedio:'我喜歡的影片',
    veryLove:'我很喜歡',
    noPCTxt: '暫無評測數據'
  }
}
